import { render, staticRenderFns } from "./help-page-layout.component.vue?vue&type=template&id=70dfdbb2&scoped=true&"
import script from "./help-page-layout.component.vue?vue&type=script&lang=ts&"
export * from "./help-page-layout.component.vue?vue&type=script&lang=ts&"
import style0 from "./help-page-layout.component.vue?vue&type=style&index=0&id=70dfdbb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dfdbb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
